<div>
  <p>
    {{
      "this_will_import_the_root_configuration_for_the_scaffold_type_set_in_this_instance"
        | translation
    }}
  </p>
  <button pButton severity="primary" (click)="updateConfiguration()">
    Update Config
  </button>
</div>
<p-accordion>
  <p-accordion-panel value="'0'">
    <p-accordion-header>
      {{ "configuration_overrides" | translation }}
    </p-accordion-header>
    <p-accordion-content>
      <p>
        {{
          "select_the_source_environment_if_you_don't_want_to_use_the_environment_of_this_instance"
            | translation
        }}:
      </p>


      <p-select [options]="envList" placeholder="Select Environment" [(ngModel)]="source" appendTo="body">
        <ng-template #selectedItem let-selectedOption>
          <span> {{selectedOption|translation}}</span>
        </ng-template>
        <ng-template let-icon #item>
          <span> {{icon|translation}}</span>
        </ng-template>
      </p-select>

      <p>
        {{'do_not_use_this_unless_you_are_absolutely_sure_you_have_a_reason_config_lingo'|translation}}
      </p>
      <p-select [options]="productsList" [(ngModel)]="type" optionLabel="text"
      optionValue="value" appendTo="body" />
    </p-accordion-content>
  </p-accordion-panel >
</p-accordion>
